import React, {useEffect, useState} from 'react';
import {fromLonLat, transform} from 'ol/proj';
import VectorSource from 'ol/source/Vector';
import VectorLayer from 'ol/layer/Vector';
import {useNavigate} from 'react-router';
import TileLayer from 'ol/layer/Tile';
import {Control, ScaleLine, defaults as defaultControls} from 'ol/control';
import Point from 'ol/geom/Point';
import Feature from 'ol/Feature';
import Overlay from 'ol/Overlay';
import OSM from 'ol/source/OSM';
import View from 'ol/View';
import Map from 'ol/Map';
import 'ol/ol.css';
import {getCityName, getShortSpecName, getCountryName} from './Trans.js';
import {mapStyles, StyleTglBtn, MapObsPopup} from './MapStyles.js';
import {useGlobalStorage} from './mobx/GlobalStorage.js';
import {dStr, tStr} from './Util.js';
import ObsAppBar from './AppBar.js';

export const LIST_MAP_MAX_ELEM	= 2000;

function ListMapMap(props) {
	const [clickFt, setClickFt] = useState({pos:0, fa:[]});
	const [obsLayer, setObsLayer] = useState(null);
	const [obsStyle, setObsStyle] = useState(1);
	const [map, setMap] = useState(null);
	const gStorage = useGlobalStorage();

	useEffect(() => {
		const initialObsLayer = new VectorLayer({source: new VectorSource()});

		const initialMap = new Map({
			target: 'mapContainer',
			controls: defaultControls({rotate: false, zoom: false}).extend([new ScaleLine({units: 'metric'})]),

			layers: [
				new TileLayer({
					source: new OSM(),
				}),
				initialObsLayer,
			],
		
			/* Zoomaa Suomen kokoiseksi */
			view: new View({
					center: fromLonLat([27.138596, 65.441896]),
					zoom: 12,
				}),
			overlays: [
				new Overlay({
					element: document.getElementById('obs-popup'),
					id: 'obs'
				}),
			],
			moveTolerance: 8
		});

		/* ---------------------------------------------------------- */

		initialMap.on('click', mapClick);
		initialMap.addControl(new Control({element: document.getElementById('style-tgl-btn')}));

		setMap(initialMap);
		setObsLayer(initialObsLayer);
		// eslint-disable-next-line
	}, []);


	function fillMap() {
		let features = [];
	
		gStorage.map.list.forEach((obs, ind) => {
			let tgtFeat = new Feature({
				geometry: new Point(transform([obs.long_obs / 1000000.0, obs.lat_obs / 1000000.0], 'EPSG:4326', 'EPSG:3857')),
				obs: obs
			});

			tgtFeat.setStyle(mapStyles[obsStyle]);
			features.push(tgtFeat);
		});

		obsLayer.setSource(
			new VectorSource({
				features: features,
			})
		)
	}
	
	useEffect(() => {
		if (!obsLayer)
			return;

		fillMap();

		map.getView().fit(obsLayer.getSource().getExtent(), {
			size: map.getSize(),
			maxZoom: 16,
			padding: [32, 32, 32, 32]});
		// eslint-disable-next-line
	}, [obsLayer]);

	useEffect(() => {
		if (!obsLayer)
			return;

		fillMap();
		// eslint-disable-next-line
	}, [obsStyle]);

	/* Update obs popup */
	useEffect(() => {
// 		console.log('useEffect clikcFt');
		if (!map) {
// 			console.log('useEffect: clikcFt null map!');
			return;
		}

		map.getOverlayById('obs').setPosition(undefined);

		if (!clickFt.fa.length || clickFt.pos >= clickFt.fa.length)
			return;

		const obs = clickFt.fa[clickFt.pos].get('obs');
		if (obs) {
			let d_str = '', t_str;

			d_str = dStr(obs.start_t);
			t_str = tStr(obs.start_t);
			if (t_str.length > 0 && t_str !== '0:00')
				d_str += ' ' + t_str;

			map.getOverlayById('obs').setPosition(clickFt.fa[clickFt.pos].coordinate);

			document.getElementById('obs-species').innerHTML = mapGetSpeciesName(gStorage.lists.speclist.list.find((taxon) => taxon.id === obs.spec_id)) + ', ' + obs.num;
			document.getElementById('obs-date').innerHTML = d_str;
			document.getElementById('obs-address').innerHTML = mapGetCityName(gStorage.lists.citylist.list.find((city) => city.id === obs.city_id)) + ', ' + obs.addr;
		}
		// eslint-disable-next-line
	}, [clickFt]);

	if (!gStorage.map.list || !gStorage.map.list.length)
		return null;

// 	console.log('ListMapMap: length', gStorage.map.list.length);
// 	gStorage.map.list.map((item, pos) => {
// 		console.log('item', item);
// 	});

	const mapClick = (e) => {
		let ft = [];

		e.map.forEachFeatureAtPixel(e.pixel, (feat) => {
			feat.coordinate = e.coordinate;
			ft.push(feat);
		});

		ft.sort((a, b) => {
			return b.get('obs').start_t - a.get('obs').start_t;
		});

		setClickFt({pos: 0, fa: ft});
	}
	
	function proceedDetails(dir) {
		setClickFt({pos: clickFt.pos + dir, fa: clickFt.fa});
	}

	function mapGetCityName(city) {
		const usr = gStorage.conn.user;
		let a_str = '';

		if (city.country !== usr.def_country) {
			const country = gStorage.lists.countrylist.find(x => x.id === city.country);
			a_str = getCountryName(country, usr) + ', ';
		}

		return a_str += getCityName(city, gStorage.conn.user);
	}

	function mapGetSpeciesName(spec) {
		return getShortSpecName(spec, gStorage.conn.user);
	}

	function toggleStyle() {
		let tmpStyle = obsStyle;

		tmpStyle++;
		if (tmpStyle >= mapStyles.length) 
			tmpStyle = 0;

		setObsStyle(tmpStyle);
	}

	return (<div id="mapContainer" style={{flexGrow: 1, height: window.innerHeight - document.getElementById('appbar').clientHeight}}>
			<MapObsPopup map={map} proceedDetails={proceedDetails} pos={clickFt.pos} num={clickFt.fa.length} />
			<StyleTglBtn tglStyle={toggleStyle} style={obsStyle}/>
	       </div>);
}

function ListMap(props) {
	const gStorage = useGlobalStorage();
	const getheader = () => gStorage.map.header;
	const navigate = useNavigate();

	const fromRefresh = document.getElementById('appbar') ? false : true;

	if (fromRefresh) {
		setTimeout(() => {
			navigate('/', { replace: true });
		}, 1);

		return null;
	}

	return (
		<div>
			<ObsAppBar getheader={getheader}/>
			<ListMapMap {...props} />
		</div>
	);
}

export default ListMap;
